<template>
  <div class="row">
    <div class="col-12" id="divToPrint" ref="content" v-if="periodos">

      <div class="col-12 mb-3" v-if="showWarning">
        <div class="message-box d-flex align-items-center bg-warning-light p-3 rounded">
          <img src="@/assets/img/megaphone.png" alt="Aviso" class="report-logo mr-3" width="50">

          <div class="alert-content w-100">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <p class="message mb-1 text-dark">
                  O relatório referente a <strong>{{ mesCorrenteFormatado }}</strong> encontra-se em fase de
                  processamento.
                </p>

                <p class="message mb-0 text-dark">
                  A versão oficial será disponibilizada para consulta após a <strong>finalização do
                    processamento</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row form_padrao">
        <div class="form-group flutuante col-md-12">
          <input type="text" name="nomeOperador" id="nomeOperador" required @keyup="filterValue($event)" />
          <label for="nomeOperador">Pesquisar periodos - ex: 2020-04</label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mt-4" v-for="(boleto, index) in newObj" :key="index">
          <div class="card card_content p-3">
            <div class="d-flex justify-content-between align-items-center">
              <i class="material-icons analytics">analytics</i>
              <router-link :to="{
                name: 'extrato-utilizacao_beneficiario',
                params: { periodo: boleto.dtref },
              }" class="badge badge-secondary">
                <i class="material-icons">visibility</i> Visualizar
              </router-link>
            </div>
            <div>
              <h6 class="text-uppercase font-weight-bolder">
                UTILIZAÇÃO X BENEFICIÁRIO
              </h6>
              <small class="text-muted pt-2">{{ boleto.dtref }}</small>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              &nbsp;
            </div>
          </div>
        </div>
        <div class="col-12" v-if="newObj.length == 0">
          <div class="card border-0 py-5 d-flex justify-content-center align-items-center">
            <h5>Nada Encontrado. 😟</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <loading />
    </div>
  </div>
</template>

<script>
import { filterByValue } from "../../helpers";
import "vue-select/dist/vue-select.css";

export default {
  name: "relatorio-utilizacao",
  data() {
    return {
      relatorio: "RelatorioResumoUtilizacaoBeneficiario",
      periodoRelatorio: "AnoMesRelatorioResumoUtilizacaoBeneficiario",
      newObj: "",
      periodos: "",
      relatorioData: "",
      selected: "",
      showWarning: false,
      mesCorrenteFormatado: "",
      produto: {
        nome: "Relatório de Utilizações x Beneficiário ",
        id: "relatorio_utilizacao",
      },
    };
  },
  watch: {
    selected(value) {
      this.getRelatorio(value.dtref);
    },
  },
  methods: {
    setCurrentMonthDisplay() {
      const date = new Date();

      // --- AQUI ESTÁ A MUDANÇA: Volta 1 mês ---
      // Usamos setDate(1) para evitar problemas com dias 29/30/31
      date.setDate(1);
      date.setMonth(date.getMonth() - 1);
      // ----------------------------------------

      // Pega o nome do mês em português (ex: "janeiro")
      const monthName = date.toLocaleString('pt-BR', { month: 'long' });

      // Pega o ano (ex: 2026)
      const year = date.getFullYear();

      // Capitaliza a primeira letra (janeiro -> Janeiro)
      const monthCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);

      // Junta tudo: Janeiro/2026
      this.mesCorrenteFormatado = `${monthCapitalized}/${year}`;
    },
    // Retorna o Mês Anterior ao atual no formato YYYY-MM
    getPreviousMonth() {
      const date = new Date();
      // Pega o dia de hoje, volta para o primeiro dia do mês anterior para evitar bugs de virada de mês (ex: 31 de março voltando 1 mes cairia em um dia inexistente de fevereiro)
      date.setDate(1);
      date.setMonth(date.getMonth() - 1);

      const year = date.getFullYear();
      // getMonth retorna 0-11, por isso +1. padStart garante o zero à esquerda
      const month = (date.getMonth() + 1).toString().padStart(2, '0');

      return `${year}-${month}`;
    },

    filterValue(value) {
      this.newObj = filterByValue(this.periodos, value.target.value);
    },

    getRelatorio(period) {
      this.$http
        .get(
          "/api/CdlBh/" +
          this.relatorio +
          "?AnoMes=" +
          period +
          "&tipoPeriodo=0"
        )
        .then((response) => {
          this.relatorioData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPeriodos() {
      this.$http
        .get("/api/CdlBh/" + this.periodoRelatorio)
        .then((response) => {
          this.periodos = response.data.reverse();
          this.newObj = response.data;

          // --- LÓGICA BLINDADA CONTRA ERROS ---
          if (this.newObj && this.newObj.length > 0) {

            // Pega o primeiro item (o mais recente após o reverse)
            const itemMaisRecente = this.newObj[0];

            // VERIFICAÇÃO DE SEGURANÇA:
            // Só entra aqui se o item existir E se o campo dtref NÃO for nulo
            if (itemMaisRecente && itemMaisRecente.dtref) {

              // Força converter para string para evitar erro caso venha número
              let valorDtRef = String(itemMaisRecente.dtref);

              // Agora é seguro usar o replace
              let ultimoPeriodoDisponivel = valorDtRef.replace(/\//g, '-').trim();
              let mesReferenciaIdeal = this.getPreviousMonth();

              console.log("=== DEBUG ===");
              console.log("Último da Base:", ultimoPeriodoDisponivel);
              console.log("Mês Anterior (Ideal):", mesReferenciaIdeal);

              if (ultimoPeriodoDisponivel < mesReferenciaIdeal) {
                this.showWarning = true;
              } else {
                this.showWarning = false;
              }

            } else {
              // Se dtref for null, não faz nada (não quebra a tela)
              console.log("Aviso: O período mais recente não possui data definida (veio null).");
              this.showWarning = false;
            }
          }
        })
        .catch((error) => {
          console.log("Erro ao buscar períodos:", error);
        });
    },
  },
  created() {
    this.setCurrentMonthDisplay();
    this.getPeriodos();
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>

<style lang="scss" scoped>
.bg-warning-light {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
}

.message-box {
  .report-logo {
    max-width: 60px;
    height: auto;
  }
}

.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: #05428e;
    color: white;

    .text-muted {
      color: white !important;
    }
  }

  small {
    line-height: 1.5rem;
  }

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;

    i {
      font-size: 13px;
      color: white;
    }
  }

  &:hover {
    transform: scale(1.05);
  }
}
</style>